import gql from "graphql-tag";

export const paycheckLineTemplateFragments = gql`
fragment paycheckLineTemplateFragments on PaycheckLineTemplate {
  id
  active
  quantity
  rate
  sum
  workRelation {
    id
  }
  mainPaycheckLineTemplate {
    id
    taxDeduction
    taxDeductionVoluntary
    garnishment
    garnishmentSamordnet
    number
    description
    altinnDescription
    altinnFordel
    calculationType
    calculatePositive
    employerTaxable
    editableFromEmployeePage
    includeInVacationMoneyBase
    vacationMoneyEarnedInPreviousYear
    vacationMoneyEarnedInCurrentYear
    taxable
  }
  car {
    id
  }
  project {
    id
  }
  department {
    id
  }
  carOverwrite
  projectOverwrite
  departmentOverwrite
}
`;
